import { initializeContext } from '~/common/bn-context/bn-context';
import {
  initialState,
  ordersDialogContextReducer,
  defaultHandler,
} from './orders-dialog-context-reducer';
import { validateStateReducerWrapper } from '~/common/bn-context/bn-context-helpers';

const { createReducer, useContextStateSelector, useContextState, useContextDispatch, BnContextProvider, useStateDispatchWrapper } = initializeContext();
export const OrdersDialogContextProvider = BnContextProvider;
export const useOrdersDialogDispatch = useContextDispatch;
export const useOrdersDialogState = useContextState;
export const useOrdersDialogStateSelector = useContextStateSelector;
export const useOrdersDialogStateDispatchWrapper = useStateDispatchWrapper;

const reducer = createReducer(ordersDialogContextReducer, defaultHandler);
export const validatedReducer = validateStateReducerWrapper(reducer, initialState);

export { initialState } from './orders-dialog-context-reducer';
